// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetail from '../../containers/analytics/SecurityDetail';


const SecurityCriticalRudimentaryDetail = ({ data }) => {
  return (
    <SecurityDetail
      data={data}
      criticality='critical'
      adequacy='rudimentary'
    />
  );
};

SecurityCriticalRudimentaryDetail.propTypes = {
  data: PropTypes.object.isRequired
};

export default SecurityCriticalRudimentaryDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityCriticalRudimentaryDetail.js